"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useScrollLock;

var _react = require("react");

function useScrollLock(isActive) {
  (0, _react.useLayoutEffect)(function () {
    var originalStyle = window.getComputedStyle(document.body).overflow;

    if (isActive) {
      document.body.style.overflow = 'hidden';
    }

    return function () {
      document.body.style.overflow = originalStyle;
    };
  }, [isActive]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy91c2VTY3JvbGxMb2NrLnRzIl0sIm5hbWVzIjpbInVzZVNjcm9sbExvY2siLCJpc0FjdGl2ZSIsIm9yaWdpbmFsU3R5bGUiLCJ3aW5kb3ciLCJnZXRDb21wdXRlZFN0eWxlIiwiZG9jdW1lbnQiLCJib2R5Iiwib3ZlcmZsb3ciLCJzdHlsZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVlLFNBQVNBLGFBQVQsQ0FBdUJDLFFBQXZCLEVBQWdEO0FBQzdELDhCQUFnQixZQUFNO0FBQ3BCLFFBQU1DLGFBQWEsR0FBR0MsTUFBTSxDQUFDQyxnQkFBUCxDQUF3QkMsUUFBUSxDQUFDQyxJQUFqQyxFQUF1Q0MsUUFBN0Q7O0FBQ0EsUUFBSU4sUUFBSixFQUFjO0FBQ1pJLE1BQUFBLFFBQVEsQ0FBQ0MsSUFBVCxDQUFjRSxLQUFkLENBQW9CRCxRQUFwQixHQUErQixRQUEvQjtBQUNEOztBQUNELFdBQU8sWUFBTTtBQUNYRixNQUFBQSxRQUFRLENBQUNDLElBQVQsQ0FBY0UsS0FBZCxDQUFvQkQsUUFBcEIsR0FBK0JMLGFBQS9CO0FBQ0QsS0FGRDtBQUdELEdBUkQsRUFRRyxDQUFDRCxRQUFELENBUkg7QUFTRCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUxheW91dEVmZmVjdCB9IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU2Nyb2xsTG9jayhpc0FjdGl2ZTogYm9vbGVhbik6IHZvaWQge1xuICB1c2VMYXlvdXRFZmZlY3QoKCkgPT4ge1xuICAgIGNvbnN0IG9yaWdpbmFsU3R5bGUgPSB3aW5kb3cuZ2V0Q29tcHV0ZWRTdHlsZShkb2N1bWVudC5ib2R5KS5vdmVyZmxvdztcbiAgICBpZiAoaXNBY3RpdmUpIHtcbiAgICAgIGRvY3VtZW50LmJvZHkuc3R5bGUub3ZlcmZsb3cgPSAnaGlkZGVuJztcbiAgICB9XG4gICAgcmV0dXJuICgpID0+IHtcbiAgICAgIGRvY3VtZW50LmJvZHkuc3R5bGUub3ZlcmZsb3cgPSBvcmlnaW5hbFN0eWxlO1xuICAgIH07XG4gIH0sIFtpc0FjdGl2ZV0pO1xufVxuIl19